"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspaceSelect = void 0;
const WorkspaceSelect_1 = __importDefault(require("./WorkspaceSelect"));
exports.WorkspaceSelect = WorkspaceSelect_1.default;
